import React from 'react';
import { connect } from 'react-redux';
import { scheduleCalendarOperations } from 'pages/ScheduleCalendar/duck';
import { ShiftApplicantsComponent } from './ShiftApplicantsComponent';

const mapStateToProps = ({
  scheduleCalendarReducer,
}) => {
  return {
    allUsers: scheduleCalendarReducer.allUsers.users,
    applicants: scheduleCalendarReducer.applicants.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  
  const approveApplicantDispatch = (shiftId, applicant) => {
    dispatch(scheduleCalendarOperations.approveApplicantOperation(shiftId, applicant));
  };
    
  const denyApplicantDispatch = (shiftId, applicant) => {
    dispatch(scheduleCalendarOperations.denyApplicantOperation(shiftId, applicant));
  };

  return {
    approveApplicantDispatch,
    denyApplicantDispatch,
  };
};

const ShiftApplicantsComponentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  const {
    approveApplicantDispatch,
    denyApplicantDispatch,
    } = props;

  return <ShiftApplicantsComponent
    approveApplicantDispatch = {approveApplicantDispatch}
    denyApplicantDispatch = {denyApplicantDispatch}
    {...props}
   /> 
});

export default ShiftApplicantsComponentContainer;